import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdArticle, MdDescription, MdMovie, MdPictureAsPdf } from "react-icons/md";
// src/modules/Files/components/FileDisplayCard/components/FileTag.tsx
var getIconNameFromType = (type) => {
	if (!type) return MdDescription;
	if (type?.includes("video")) return MdMovie;
	if (type?.includes("pdf")) return MdPictureAsPdf;
	if (type?.includes("document")) return MdArticle;
	return MdDescription;
};
var FileTag = ({ name, onClick, type = "File" }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "space-x-xs border-border bg-surface p-xs hover:bg-surface-strong active:bg-surface-subtle flex cursor-pointer items-center justify-center rounded border transition hover:shadow-sm",
		onClick,
		children: [/* @__PURE__ */ jsx(Icon, { Icon: getIconNameFromType(type) }), /* @__PURE__ */ jsxs("div", {
			className: "max-w-[175px]",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle truncate text-sm text-[10px] capitalize",
				children: type
			}), /* @__PURE__ */ jsx("div", {
				className: "truncate text-[10px]",
				children: name
			})]
		})]
	});
};
export { FileTag };

//# sourceMappingURL=FileTag.js.map